import { render } from "./Article_Item.vue?vue&type=template&id=15d3d27c"
import script from "./Article_Item.vue?vue&type=script&lang=js"
export * from "./Article_Item.vue?vue&type=script&lang=js"

import "./Article_Item.vue?vue&type=style&index=0&id=15d3d27c&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__